import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ticketsQueryKey } from '../queries/useTickets'
import { TicketComment } from '../types'

export function useAddTicketComment() {
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function addComment({
    ticketId,
    text,
    attachments
  }: {
    ticketId: string
    text: string
    attachments: File[]
  }) {
    const formData = new FormData()
    formData.append('text', text)
    attachments.forEach((file) => formData.append('attachments', file))

    const res = await apiClient.post<TicketComment>(
      `${SNA_PREFIX}tickets/${ticketId}/comments/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return res.data
  }

  return useMutation({
    mutationFn: addComment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ticketsQueryKey })
    },
    onError
  })
}
